import { QueryKeys } from 'types/dev';
import { useQuery } from '@tanstack/react-query';

async function getInstitutionCode(): Promise<{ institutionCode: string }> {
  const result = await fetch('./config/metadata.json');
  return await result.json();
}

export default function useInstitutionCode(): { institutionCode: string } | undefined {
  const { data } = useQuery([QueryKeys.INSTITUTION_CODE], getInstitutionCode);
  return data;
}
